import router from './router'
import store from './store'
import {
	Message
} from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style

NProgress.configure({
	showSpinner: false
}) // NProgress Configuration

let url = ''
let getPath = (arr) => {
	if (arr[0].children) {
		getPath(arr[0].children)
	} else {
		url = arr[0].meta.url
	}
}

const whiteList = ['/login', '/auth-redirect'] // no redirect whitelist
router.beforeEach(async (to, from, next) => {
	// start progress bar
	NProgress.start()
	// determine whether the user has logged in
	const hasToken = window.localStorage.getItem('access_token')
	if (hasToken) {
		if (to.path === '/empty') {
			next()
			NProgress.done()
		} else if (to.path === '/login') {
			getPath(store.getters.addRoutes)
			next(url)
			NProgress.done()
		} else {
			const hasRoles = store.getters.role
			if (hasRoles) {
				if (to.path === '/') {
					getPath(store.getters.addRoutes)
					next(url)
				} else {
					let flag = false
					let getUrl = (arr) => {
						arr.forEach((item, index) => {
							if (item.meta && item.meta.url && to.path === item.meta.url || to
								.path === '/404') {
								flag = true
							}
							if (item.children && item.children.length) {
								getUrl(item.children)
							}
						})
					}
					getUrl(store.getters.addRoutes)
					next()
					if (flag) {} else {
						// next('/404')
					}
				}
				NProgress.done()
			} else {
				try {
					const data = await store.dispatch('user/getInfo')
					const accessRoutes = await store.dispatch('permission/generateRoutes', data.type)
					accessRoutes.forEach(routeConfig => {
						router.addRoute(routeConfig);
					})
					if (to.path === '/') {
						getPath(accessRoutes)
						next(url)
					} else {
						let flag = false
						let getUrl = (arr) => {
							arr.forEach((item, index) => {
								if (item.meta && item.meta.url && to.path === item.meta.url ||
									to.path === '/404') {
									flag = true
								}
								if (item.children && item.children.length) {
									getUrl(item.children)
								}
							})
						}
						getUrl(accessRoutes)
						if (flag) {
							next({
								...to,
								replace: true
							})
						} else if (to.path === '/not-permission') {
							next()
						} else {
							next('/404')
						}

					}
				} catch (error) {
					Message.error(error || 'Has Error')
					next(`/login?redirect=${to.path}`)
					NProgress.done()
				}
			}
		}
	} else {
		/* has no token*/

		if (whiteList.indexOf(to.path) !== -1) {
			// in the free login whitelist, go directly
			next()
		} else {
			// other pages that do not have permission to access are redirected to the login page.
			next(`/login?redirect=${to.path}`)
			NProgress.done()
		}
	}
})

router.afterEach(() => {
	// finish progress bar
	NProgress.done()
})